export default __webpack_public_path__ + "static/media/roadmap-head-shark-8.02731794.png";